<div class="login-parent">
  <div class="logo">
    <!-- <img src="../../../../assets/images/main-icon.png"> -->
  </div>
  <div class="login-form">
  </div>
</div>